<button
	*ngIf="isVisible"
	type="button"
	class="update-badge"
	[title]="updateName"
	[attr.aria-label]="'View updates: ' + updateName"
	aria-haspopup="dialog"
	(click)="openUpdates()"
>
	{{ updateName | ngTruncate: [50, '…'] }}
</button>
